import { useEffect } from 'react';

export default function useOutsideComponent(ref: any, buttonRef: any, cb: Function, visibility: boolean) {
  useEffect(() => {
    /**
     * Execute callback if clicked on outside of element
     */
    function handleClickOutside(event: MouseEvent) {
      if (ref.current && ref.current.contains(event.target)) {
        return;
      }

      if (buttonRef.current && buttonRef.current.contains(event.target)) {
        return;
      }

      cb();
    }

    // Bind the event listener
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref, buttonRef, cb, visibility]);
}
